class ExpandableCards {

  constructor(element) {
    this.element = element
    this.listen()
  }

  listen() {
    this.element.addEventListener("click", (ev) => {
      if (ev.target.classList.contains("card-expandable__expand-button")) {
        const container = ev.target.closest(".card-expandable__inner");
        if (!container.classList.contains("expanded")) {
          const contentEl = ev.target.parentElement.previousElementSibling
          if (contentEl.hasAttribute("style")) {
            contentEl.removeAttribute("style")
            ev.target.innerText = "Read More"
          } else {
            contentEl.style.maxHeight = contentEl.scrollHeight + "px"
            ev.target.innerText = "Close"
          }
        }
      }
    })
  }
}

export default ExpandableCards